module.exports = __webpack_public_path__ + "static/img/zyyy.fde1950.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/zyyy.png
// module id = EXGS
// module chunks = 0